// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1448":"56280fa7","2692":"2bcecf73","7153":"d15b140d","9648":"bad528b7"}[chunkId] + ".chunk.css";
};